import React, { useEffect, useRef } from 'react';
import ActionCable from 'actioncable';
import {useAuth} from "../../../contexts/AuthContext";
import {API_CABLE_ENDPOINT} from "../../../constants/apiConstants";

const WebSocketConnection = ({ setPayload }) => {
    const { auth } = useAuth();
    const cableRef = useRef(null);
    const subscriptionRef = useRef(null);

    useEffect(() => {
        if (auth.token && !cableRef.current) {
            // Create a new ActionCable consumer
            cableRef.current = ActionCable.createConsumer(`${API_CABLE_ENDPOINT}/cable?token=${auth.token?.replace("Bearer ", "")}`);

            // Subscribe to the 'ScreenUpdatesChannel'
            subscriptionRef.current = cableRef.current.subscriptions.create("ScreenUpdatesChannel", {
                connected() {
                    // console.log('WebSocket connected successfully');
                },
                disconnected() {
                    // console.log('WebSocket disconnected');
                    // Implement reconnection logic or error handling here
                },
                received(data) {
                    // console.log('Received data:', data);
                    setPayload(data?.payload);
                    // Handle incoming data
                },
                rejected() {
                    console.log('Subscription rejected:');
                    // Handle rejection here
                }
            });
        }

        return () => {
            if (subscriptionRef.current) {
                // subscriptionRef.current.unsubscribe();
                // console.log('Unsubscribed from the channel');
            }
            if (cableRef.current) {
                // cableRef.current.disconnect();
                // console.log('Disconnected ActionCable consumer');
            }
        };
    }, [auth.token, setPayload]); // Dependency on auth.token

    return null;
};

export default WebSocketConnection;
